<div class="accordion-container" [ngStyle]="{ width: width ? width : '' }">
  <ng-content></ng-content>
</div>
